import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Text } from "@pentabd/ui";

import { DetailsColumn } from "./DetailsColumn";
import { ManpowerTable } from "./ManpowerTable";
import { SummaryColumn } from "./SummaryColumn";
import { TableFilter } from "./TableFilter";

import { useManpowerReports } from "@hooks/HRM/reports/useManpowerReports";
import { useQueries } from "@hooks/useQueries";

export const Manpower = () => {
  const { t } = useTranslation();

  const {
    // handleParams,
    getManpowerReportSummaryData,
    getManpowerReportDetailsData,
    handleQuery,
  } = useManpowerReports();

  const { setSearchParams } = useQueries();

  useEffect(() => {
    setSearchParams(undefined);
  }, []);

  return (
    <div className="pt-10">
      {/* filters */}
      {/* {getManpowerReportDetailsData?.length > 0 && (
      )} */}
      <TableFilter handleQuery={handleQuery} />

      {/* summary table */}
      <div className="pt-10">
        <Text
          weight="semibold"
          color="title"
          size="lg"
          className={`text-center d-block text-underline ${
            !getManpowerReportSummaryData?.positionNameBn && "d-none"
          }`}
        >
          {getManpowerReportSummaryData?.positionNameBn}
        </Text>
        <div className="pt-10">
          <ManpowerTable
            column={SummaryColumn(t)}
            rows={getManpowerReportSummaryData?.data || []}
          />
        </div>
      </div>

      {/* details table will show after selecting designation */}

      {getManpowerReportDetailsData?.length > 0 &&
        getManpowerReportDetailsData?.map(
          (item: any, i: number) =>
            item?.data?.length > 0 && (
              <div className="pt-10" key={i}>
                <Text
                  weight="semibold"
                  color="title"
                  size="lg"
                  className={`text-center d-block text-underline ${
                    !item?.name && "d-none"
                  }`}
                >
                  {item?.name}
                </Text>
                <div className="pt-10">
                  <ManpowerTable
                    column={DetailsColumn(t)}
                    rows={item?.data || []}
                    height={item?.data?.length > 5 ? 500 : undefined}
                  />
                </div>
              </div>
            ),
        )}
    </div>
  );
};
